document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".variant-input").forEach(button => {
    button.addEventListener("click", function () {
      console.log('clicked')
      pickInventoryMessage()
    })
  })
  pickInventoryMessage()
})

function pickInventoryMessage() {
  $(".variant-input input").each(function(i) {
    if (this.checked) {
        $('.product-block--inventory:eq(' + i + ')').css("display", "inline")
    }
    else {
        $('.product-block--inventory:eq(' + i + ')').css("display", "none")       
    }
  });
  if($(".variant-input input").length == 0) {
    $('.product-block--inventory:eq(0)').css("display", "inline")    
  }
}